const { formatText } = require('core/i18n').i18n;

function getArrayDocuments() {

    const idSendOptions = [
        {
            label: formatText("stepClientLogin-optionGoToGlobalPosition"),
            value: '/myprofile/global',
            global: true
        },
        {
            label: formatText("stepClientLogin-optionSendN1OTP"),
            value: '/keys/send'
        },
        {
            label: formatText("stepClientLogin-optionSendN2Post"),
            value: '/keys/send-n2-post'
        }
    ];

    return idSendOptions;
}

module.exports = {
    getArrayDocuments,
};
